import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { WaterfallLabor } from '~/core/models';

export const waterfallLaborApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    getWaterfallLaborFee: builder.query<
      WaterfallLabor,
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: ApiUrl.WATERFALL_LABOR,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetWaterfallLaborFeeQuery } = waterfallLaborApi;
